import { ReportData } from '../types/reportTypes';

// April 2026 Sales Data - Standard Report (38 jobs from Sales CSV)
// Source: sample csv/2025 TLLG Marketing Leads Report - ROI Exteriors - Sales Apr26.csv
// Trade names: "ROI " prefix stripped, multi-trade entries use first trade only
//   - E-1019 Wentworth: "ROI Siding, ROI Gutters" -> "Siding"
//   - E-1002 Jackson: "ROI Insulation, ROI Roofing" -> "Insulation"
//   - E-1004 Iadarola: "ROI Siding, ROI Windows & Doors, ROI Roofing" -> "Siding"
// Sum-of-rows used per Rule 1 (CSV Totals row had small rounding drift on GP $283,508.83 vs $283,508.84,
// Manager $5,696.98 vs $5,696.97, OH $88,303.22 vs $88,303.29).
const jobData = [
  {
    jobInfo: "E-1032: Mary Miller",
    leadSource: "Thumbtack",
    trade: "Windows & Doors",
    contractTotal: 9786.00,
    grossMarginPct: 0.5397,
    grossProfit: 5281.50,
    commissionPercentage: 7.00,
    salesCommission: 685.02,
    salesManagerFee: 97.86,
    companyOH: 1516.83,
    netProfit: 0
  },
  {
    jobInfo: "E-1015: Theodore & Jessica Fleming",
    leadSource: "Google Organic Search",
    trade: "Windows & Doors",
    contractTotal: 9067.35,
    grossMarginPct: 0.4972,
    grossProfit: 4508.29,
    commissionPercentage: 4.00,
    salesCommission: 362.69,
    salesManagerFee: 90.67,
    companyOH: 1405.44,
    netProfit: 0
  },
  {
    jobInfo: "E-1011: Michele Callaghan",
    leadSource: "Self Generated Lead (By Rep)",
    trade: "Windows & Doors",
    contractTotal: 3333.46,
    grossMarginPct: 0.5408,
    grossProfit: 1802.74,
    commissionPercentage: 7.00,
    salesCommission: 233.34,
    salesManagerFee: 33.33,
    companyOH: 516.69,
    netProfit: 0
  },
  {
    jobInfo: "E-1006: Rita Robertazzi",
    leadSource: "Referral - Word of mouth",
    trade: "Windows & Doors",
    contractTotal: 5972.00,
    grossMarginPct: 0.4582,
    grossProfit: 2736.37,
    commissionPercentage: 4.00,
    salesCommission: 238.88,
    salesManagerFee: 59.72,
    companyOH: 925.66,
    netProfit: 0
  },
  {
    jobInfo: "E-1013: Mark & Kathleen Wagner",
    leadSource: "Angi",
    trade: "Windows & Doors",
    contractTotal: 1972.00,
    grossMarginPct: 0.4223,
    grossProfit: 832.78,
    commissionPercentage: 4.00,
    salesCommission: 78.88,
    salesManagerFee: 19.72,
    companyOH: 305.66,
    netProfit: 0
  },
  {
    jobInfo: "E-1030: Sharon Mack",
    leadSource: "Previous Customer",
    trade: "Windows & Doors",
    contractTotal: 5859.00,
    grossMarginPct: 0.5997,
    grossProfit: 3513.64,
    commissionPercentage: 7.00,
    salesCommission: 410.13,
    salesManagerFee: 58.59,
    companyOH: 908.15,
    netProfit: 0
  },
  {
    jobInfo: "E-1019: Russ & Hwasook Wentworth",
    leadSource: "Google Organic Search",
    trade: "Siding",
    contractTotal: 25572.00,
    grossMarginPct: 0.4162,
    grossProfit: 10643.07,
    commissionPercentage: 4.00,
    salesCommission: 1022.88,
    salesManagerFee: 255.72,
    companyOH: 3963.66,
    netProfit: 0
  },
  {
    jobInfo: "E-1024: Luisa & Sean Malcherek",
    leadSource: "Google Organic Search",
    trade: "Windows & Doors",
    contractTotal: 24289.00,
    grossMarginPct: 0.4201,
    grossProfit: 10203.81,
    commissionPercentage: 4.00,
    salesCommission: 971.56,
    salesManagerFee: 242.89,
    companyOH: 3764.80,
    netProfit: 0
  },
  {
    jobInfo: "E-986: Jessica & Kevin Brilhart",
    leadSource: "Yelp",
    trade: "Windows & Doors",
    contractTotal: 17934.00,
    grossMarginPct: 0.4509,
    grossProfit: 8086.44,
    commissionPercentage: 4.00,
    salesCommission: 717.36,
    salesManagerFee: 179.34,
    companyOH: 2779.77,
    netProfit: 0
  },
  {
    jobInfo: "Mitch Pollard",
    leadSource: "Thumbtack",
    trade: "Windows & Doors",
    contractTotal: 12850.00,
    grossMarginPct: 0.4000,
    grossProfit: 5140.00,
    commissionPercentage: 4.00,
    salesCommission: 514.00,
    salesManagerFee: 128.50,
    companyOH: 1991.75,
    netProfit: 0
  },
  {
    jobInfo: "E-1021: Belkacem Manseur",
    leadSource: "Events Division",
    trade: "Windows & Doors",
    contractTotal: 8972.00,
    grossMarginPct: 0.4000,
    grossProfit: 3588.80,
    commissionPercentage: 4.00,
    salesCommission: 358.88,
    salesManagerFee: 89.72,
    companyOH: 1390.66,
    netProfit: 0
  },
  {
    jobInfo: "E-1023: John Protzman",
    leadSource: "Angi",
    trade: "Windows & Doors",
    contractTotal: 7800.00,
    grossMarginPct: 0.4000,
    grossProfit: 3120.00,
    commissionPercentage: 4.00,
    salesCommission: 312.00,
    salesManagerFee: 78.00,
    companyOH: 1209.00,
    netProfit: 0
  },
  {
    jobInfo: "E-1031: Zarin Newman",
    leadSource: "Google Organic Search",
    trade: "Windows & Doors",
    contractTotal: 8674.00,
    grossMarginPct: 0.4000,
    grossProfit: 3469.60,
    commissionPercentage: 4.00,
    salesCommission: 346.96,
    salesManagerFee: 86.74,
    companyOH: 1344.47,
    netProfit: 0
  },
  {
    jobInfo: "Zarin & Andrea Newman",
    leadSource: "Google Organic Search",
    trade: "Windows & Doors",
    contractTotal: 10602.00,
    grossMarginPct: 0.4000,
    grossProfit: 4240.80,
    commissionPercentage: 4.00,
    salesCommission: 424.08,
    salesManagerFee: 106.02,
    companyOH: 1643.31,
    netProfit: 0
  },
  {
    jobInfo: "Barbara Covington",
    leadSource: "Thumbtack",
    trade: "Windows & Doors",
    contractTotal: 5187.00,
    grossMarginPct: 0.4000,
    grossProfit: 2074.80,
    commissionPercentage: 4.00,
    salesCommission: 207.48,
    salesManagerFee: 51.87,
    companyOH: 803.99,
    netProfit: 0
  },
  {
    jobInfo: "Misrak & Gazew Chekol Asege",
    leadSource: "Previous Customer",
    trade: "Windows & Doors",
    contractTotal: 7000.00,
    grossMarginPct: 0.4000,
    grossProfit: 2800.00,
    commissionPercentage: 4.00,
    salesCommission: 280.00,
    salesManagerFee: 70.00,
    companyOH: 1085.00,
    netProfit: 0
  },
  {
    jobInfo: "E-1010: Angie Millette",
    leadSource: "Angi",
    trade: "Insulation",
    contractTotal: 3799.00,
    grossMarginPct: 0.6956,
    grossProfit: 2642.58,
    commissionPercentage: 10.00,
    salesCommission: 379.90,
    salesManagerFee: 37.99,
    companyOH: 588.85,
    netProfit: 0
  },
  {
    jobInfo: "E-995: Olivia & Victoria Devillier",
    leadSource: "Google Organic Search",
    trade: "Windows & Doors",
    contractTotal: 9872.00,
    grossMarginPct: 0.4059,
    grossProfit: 4007.04,
    commissionPercentage: 4.00,
    salesCommission: 394.88,
    salesManagerFee: 98.72,
    companyOH: 1530.16,
    netProfit: 0
  },
  {
    jobInfo: "E-978: Meredith Griggs",
    leadSource: "Previous Customer",
    trade: "Roofing",
    contractTotal: 19363.00,
    grossMarginPct: 0.5040,
    grossProfit: 9758.95,
    commissionPercentage: 7.00,
    salesCommission: 1355.41,
    salesManagerFee: 193.63,
    companyOH: 3001.27,
    netProfit: 0
  },
  {
    jobInfo: "E-998: PAUL SLUBY JR",
    leadSource: "Previous Customer",
    trade: "Windows & Doors",
    contractTotal: 33999.00,
    grossMarginPct: 0.5422,
    grossProfit: 18434.26,
    commissionPercentage: 7.00,
    salesCommission: 2379.93,
    salesManagerFee: 339.99,
    companyOH: 5269.85,
    netProfit: 0
  },
  {
    jobInfo: "E-977: Erik & Kiarie Monterosso",
    leadSource: "Google Organic Search",
    trade: "Windows & Doors",
    contractTotal: 19872.00,
    grossMarginPct: 0.5205,
    grossProfit: 10343.38,
    commissionPercentage: 7.00,
    salesCommission: 1391.04,
    salesManagerFee: 198.72,
    companyOH: 3080.16,
    netProfit: 0
  },
  {
    jobInfo: "E-975: Emily & John Tuebner",
    leadSource: "Google Organic Search",
    trade: "Windows & Doors",
    contractTotal: 8991.00,
    grossMarginPct: 0.5299,
    grossProfit: 4764.33,
    commissionPercentage: 7.00,
    salesCommission: 629.37,
    salesManagerFee: 89.91,
    companyOH: 1393.61,
    netProfit: 0
  },
  {
    jobInfo: "E-976: Jacqueline & Dwight Juarez Neale",
    leadSource: "Yelp",
    trade: "Windows & Doors",
    contractTotal: 12621.00,
    grossMarginPct: 0.4060,
    grossProfit: 5124.13,
    commissionPercentage: 4.00,
    salesCommission: 504.84,
    salesManagerFee: 126.21,
    companyOH: 1956.26,
    netProfit: 0
  },
  {
    jobInfo: "E-996: Felecia & Gerelene Womack",
    leadSource: "Angi",
    trade: "Attic Insulation",
    contractTotal: 3983.00,
    grossMarginPct: 0.5732,
    grossProfit: 2283.06,
    commissionPercentage: 7.00,
    salesCommission: 278.81,
    salesManagerFee: 39.83,
    companyOH: 617.37,
    netProfit: 0
  },
  {
    jobInfo: "E-985: Twila Mitchell",
    leadSource: "Google Organic Search",
    trade: "Roofing",
    contractTotal: 9772.00,
    grossMarginPct: 0.4751,
    grossProfit: 4642.68,
    commissionPercentage: 4.00,
    salesCommission: 390.88,
    salesManagerFee: 97.72,
    companyOH: 1514.66,
    netProfit: 0
  },
  {
    jobInfo: "E-983: Jake Marshak & Susan Wilkinson",
    leadSource: "Yelp",
    trade: "Gutters",
    contractTotal: 7548.00,
    grossMarginPct: 0.6319,
    grossProfit: 4769.58,
    commissionPercentage: 10.00,
    salesCommission: 754.80,
    salesManagerFee: 75.48,
    companyOH: 1169.94,
    netProfit: 0
  },
  {
    jobInfo: "E-991: Patrick Matejka",
    leadSource: "Google Organic Search",
    trade: "Roofing",
    contractTotal: 16578.40,
    grossMarginPct: 0.4865,
    grossProfit: 8065.39,
    commissionPercentage: 4.00,
    salesCommission: 663.14,
    salesManagerFee: 165.78,
    companyOH: 2569.65,
    netProfit: 0
  },
  {
    jobInfo: "E-968: Hank & Constance Wiese",
    leadSource: "Google Organic Search",
    trade: "Insulation",
    contractTotal: 2208.00,
    grossMarginPct: 0.5681,
    grossProfit: 1254.36,
    commissionPercentage: 7.00,
    salesCommission: 154.56,
    salesManagerFee: 22.08,
    companyOH: 342.24,
    netProfit: 0
  },
  {
    jobInfo: "E-959: William Taylor",
    leadSource: "Yelp",
    trade: "Roofing",
    contractTotal: 6950.00,
    grossMarginPct: 0.4431,
    grossProfit: 3079.55,
    commissionPercentage: 4.00,
    salesCommission: 278.00,
    salesManagerFee: 69.50,
    companyOH: 1077.25,
    netProfit: 0
  },
  {
    jobInfo: "E-1022: Tilahun Dejene",
    leadSource: "Referral - Word of mouth",
    trade: "Roofing",
    contractTotal: 19872.00,
    grossMarginPct: 0.4839,
    grossProfit: 9616.06,
    commissionPercentage: 4.00,
    salesCommission: 794.88,
    salesManagerFee: 198.72,
    companyOH: 3080.16,
    netProfit: 0
  },
  {
    jobInfo: "E-1002: Antionette Jackson",
    leadSource: "eLocal",
    trade: "Insulation",
    contractTotal: 36551.00,
    grossMarginPct: 0.6283,
    grossProfit: 22964.99,
    commissionPercentage: 10.00,
    salesCommission: 3655.10,
    salesManagerFee: 365.51,
    companyOH: 5665.41,
    netProfit: 0
  },
  {
    jobInfo: "E-1037: Jacqueline & Cameron Toth",
    leadSource: "Yelp",
    trade: "Roofing",
    contractTotal: 8900.00,
    grossMarginPct: 0.4740,
    grossProfit: 4218.60,
    commissionPercentage: 4.00,
    salesCommission: 356.00,
    salesManagerFee: 89.00,
    companyOH: 1379.50,
    netProfit: 0
  },
  {
    jobInfo: "E-1003: Alan Borock",
    leadSource: "Yelp",
    trade: "Roofing",
    contractTotal: 16910.00,
    grossMarginPct: 0.5177,
    grossProfit: 8754.31,
    commissionPercentage: 7.00,
    salesCommission: 1183.70,
    salesManagerFee: 169.10,
    companyOH: 2621.05,
    netProfit: 0
  },
  {
    jobInfo: "Jim & Andrea Bremer",
    leadSource: "Yelp",
    trade: "Roofing",
    contractTotal: 66537.00,
    grossMarginPct: 0.4000,
    grossProfit: 26614.80,
    commissionPercentage: 4.00,
    salesCommission: 2661.48,
    salesManagerFee: 665.37,
    companyOH: 10313.24,
    netProfit: 0
  },
  {
    jobInfo: "E-1004: Elizabeth & Lew Iadarola",
    leadSource: "Yelp",
    trade: "Siding",
    contractTotal: 64472.00,
    grossMarginPct: 0.6230,
    grossProfit: 40166.06,
    commissionPercentage: 10.00,
    salesCommission: 6447.20,
    salesManagerFee: 644.72,
    companyOH: 9993.16,
    netProfit: 0
  },
  {
    jobInfo: "E-1001: Lynne O\u2019Keefe",
    leadSource: "Previous Customer",
    trade: "Roofing",
    contractTotal: 13819.00,
    grossMarginPct: 0.5851,
    grossProfit: 8085.50,
    commissionPercentage: 7.00,
    salesCommission: 967.33,
    salesManagerFee: 138.19,
    companyOH: 2141.95,
    netProfit: 0
  },
  {
    jobInfo: "E-1005: Debra Small",
    leadSource: "Google Organic Search",
    trade: "Roofing",
    contractTotal: 13214.00,
    grossMarginPct: 0.5094,
    grossProfit: 6731.21,
    commissionPercentage: 7.00,
    salesCommission: 924.98,
    salesManagerFee: 132.14,
    companyOH: 2048.17,
    netProfit: 0
  },
  {
    jobInfo: "E-1009: Theresa & Troy Moses Henneghen",
    leadSource: "Google Organic Search",
    trade: "Roofing",
    contractTotal: 8997.00,
    grossMarginPct: 0.5719,
    grossProfit: 5145.38,
    commissionPercentage: 7.00,
    salesCommission: 629.79,
    salesManagerFee: 89.97,
    companyOH: 1394.54,
    netProfit: 0
  }
];

// Apply business logic to calculate net profit (Standard Report formula)
jobData.forEach(job => {
  job.netProfit = job.grossProfit - (job.salesCommission + job.salesManagerFee + job.companyOH);
});

// Calculate totals
const totalContractValue = jobData.reduce((sum, job) => sum + job.contractTotal, 0);
const totalGrossProfit = jobData.reduce((sum, job) => sum + job.grossProfit, 0);
const totalSalesCommissions = jobData.reduce((sum, job) => sum + job.salesCommission, 0);
const totalManagerFees = jobData.reduce((sum, job) => sum + job.salesManagerFee, 0);
const totalCompanyOH = jobData.reduce((sum, job) => sum + job.companyOH, 0);
const totalNetProfit = jobData.reduce((sum, job) => sum + job.netProfit, 0);

// Ad spend data from April 2026 Ad Spend CSV
// Source: sample csv/2025 TLLG Marketing Leads Report - ROI Exteriors - AdSpendApr26.csv
// Sum matches sales CSV header ($81,064.95) and ad spend CSV footer total.
const adSpendData = [
  { source: "Networx", spend: 666.74 },
  { source: "Thumbtack", spend: 9900.00 },
  { source: "Yelp", spend: 11054.38 },
  { source: "Porch", spend: 0.00 },
  { source: "Web to Lead Form", spend: 1380.00 },
  { source: "Angi", spend: 5000.00 },
  { source: "RoofHero", spend: 1978.00 },
  { source: "Google Organic Search", spend: 5500.00 },
  { source: "Google Paid Search", spend: 34500.00 },
  { source: "Facebook / Meta Ads", spend: 785.83 },
  { source: "Missed Call", spend: 0.00 },
  { source: "Previous Customer", spend: 0.00 },
  { source: "Referral - From past customer", spend: 0.00 },
  { source: "DataDump GoHighLevel", spend: 0.00 },
  { source: "Referral - Word of mouth", spend: 0.00 },
  { source: "Email Campaign", spend: 0.00 },
  { source: "SpringConnect - Call Center", spend: 0.00 },
  { source: "Self Generated Lead (By Rep)", spend: 0.00 },
  { source: "BBB", spend: 300.00 },
  { source: "Events Division", spend: 7500.00 },
  { source: "Yard Sign", spend: 0.00 },
  { source: "ROI Sales Portal", spend: 0.00 },
  { source: "Modernize", spend: 0.00 },
  { source: "33 Mile Radius / Everconnect", spend: 0.00 },
  { source: "eLocal", spend: 2500.00 }
];

const totalAdSpend = adSpendData.reduce((sum, item) => sum + item.spend, 0);

// Aggregate sales by source
const salesBySourceMap = jobData.reduce((acc, job) => {
  const source = job.leadSource;
  if (!acc[source]) {
    acc[source] = {
      source,
      totalSales: 0,
      count: 0,
      grossProfit: 0
    };
  }
  acc[source].totalSales += job.contractTotal;
  acc[source].count += 1;
  acc[source].grossProfit += job.grossProfit;
  return acc;
}, {} as Record<string, { source: string; totalSales: number; count: number; grossProfit: number }>);

const salesBySource = Object.values(salesBySourceMap).sort((a, b) => b.totalSales - a.totalSales);

// Aggregate sales by trade
const salesByTradeMap = jobData.reduce((acc, job) => {
  const trade = job.trade;
  if (!acc[trade]) {
    acc[trade] = {
      trade,
      totalSales: 0,
      count: 0,
      grossProfit: 0
    };
  }
  acc[trade].totalSales += job.contractTotal;
  acc[trade].count += 1;
  acc[trade].grossProfit += job.grossProfit;
  return acc;
}, {} as Record<string, { trade: string; totalSales: number; count: number; grossProfit: number }>);

const salesByTrade = Object.values(salesByTradeMap).sort((a, b) => b.totalSales - a.totalSales);

export const april2026Data: ReportData = {
  kpis: {
    adSpend: totalAdSpend,
    totalSales: totalContractValue,
    grossProfit: totalGrossProfit,
    salesCommissions: totalSalesCommissions,
    managerFees: totalManagerFees,
    companyOH: totalCompanyOH,
    netProfit: totalNetProfit - totalAdSpend,
    netProfitPercent: (totalNetProfit - totalAdSpend) / totalContractValue,
    grossProfitPercent: totalGrossProfit / totalContractValue
  },

  adSpendBySource: adSpendData,
  salesBySource: salesBySource,
  salesByTrade: salesByTrade,
  jobData: jobData,

  period: {
    month: 4,
    year: 2026
  }
};
